import React from 'react';
import { useEffect, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { CROSS_REFERENCE_MODAL_COMMAND, PhxCrossReferenceLinkNode } from '../../nodes/PhxCrossReferenceLinkNode';
import CrossReferenceDialog from './CrossReferenceDialog';

export default function CrossReferencePlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();
  const [showDialog, setShowDialog] = useState(false);
  const [editingNodeKey, setEditingNodeKey] = useState<string | null>(null);

  useEffect(() => {
    PhxCrossReferenceLinkNode.setEditor(editor);

    return editor.registerCommand(
      CROSS_REFERENCE_MODAL_COMMAND,
      (payload) => {
        setEditingNodeKey(payload.nodeKey);
        setShowDialog(true);
        return true;
      },
      1
    );
  }, [editor]);

  const handleClose = () => {
    setShowDialog(false);
    setEditingNodeKey(null);
  };

  const handleSelectReference = () => {
    // This is handled within the dialog component
  };

  return showDialog ? (
    <CrossReferenceDialog
      open={showDialog}
      onClose={handleClose}
      onSelectReference={handleSelectReference}
      activeEditor={editor}
      editingNodeKey={editingNodeKey}
    />
  ) : null;
}
